/* eslint-disable no-param-reassign */
/* qeslint-disable */
// q@ts-nocheck

import { DeveloperError } from "cesium";

/**
 * If element is a string, look up the element in the DOM by ID.  Otherwise return element.
 *
 * @private
 *
 * @exception {DeveloperError} Element with id "id" does not exist in the document.
 */
function getElement(element: Element | string) {
    if (typeof element === "string") {
        const foundElement = document.getElementById(element);

        // >>includeStart('debug', pragmas.debug);
        if (foundElement === null) {
            throw new DeveloperError(`Element with id "${element}" does not exist in the document.`);
        }
        // >>includeEnd('debug');

        // @ts-ignore
        element = foundElement;
    }

    return element;
}
export default getElement;
